module.exports = __webpack_public_path__ + "static/media/routing.33627951.jpeg";